__turbopack_context__.v({
  "active": "Chip-module-scss-module__z-FIXG__active",
  "chip": "Chip-module-scss-module__z-FIXG__chip",
  "disabled": "Chip-module-scss-module__z-FIXG__disabled",
  "overlay": "Chip-module-scss-module__z-FIXG__overlay",
});
